module.exports = __webpack_public_path__ + "img/times_black.c4f3f249.svg";